import { DisablerActionTypes } from './actionTypes';
import type { DisablerActions } from './actions';

import type { DisablerDevice, DisablerEvent } from '@cobliteam/common-types';

import { type WebData, isWebDataSuccess, mapWebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface DisablerState {
  disablerDevicesWebData: WebData<DisablerDevice[]>;
  disablerDevicesStatusWebData: WebData<DisablerEvent[]>;
}

export const disablerInitialState: DisablerState = {
  disablerDevicesWebData: webDataNotAsked(),
  disablerDevicesStatusWebData: webDataNotAsked(),
};

export const disablerReducer = (state: DisablerState = disablerInitialState, action: DisablerActions): DisablerState => {
  switch (action.type) {
    case DisablerActionTypes.LOAD_DEVICES_STATUS_REQUEST:
      return { ...state, disablerDevicesStatusWebData: webDataFetching() };

    case DisablerActionTypes.LOAD_DEVICES_STATUS_SUCCEEDED:
      return {
        ...state,
        disablerDevicesStatusWebData: webDataSuccess(action.payload),
      };

    case DisablerActionTypes.LOAD_DEVICES_STATUS_FAILED:
      return { ...state, disablerDevicesStatusWebData: webDataError() };

    case DisablerActionTypes.ASK_DISABLER_ACTION_SUCCEEDED:
      const { deviceId, requestedAction } = action.payload;
      const newDisablerDevice: DisablerDevice = {
        deviceId,
        action: requestedAction,
      };

      if (isWebDataSuccess(state.disablerDevicesWebData)) {
        return {
          ...state,
          disablerDevicesWebData: mapWebData((disablerDevices: DisablerDevice[]) => {
            const otherDevices = disablerDevices.filter((device) => device.deviceId !== action.payload.deviceId);

            return [...otherDevices, newDisablerDevice];
          })(state.disablerDevicesWebData),
        };
      }

      return {
        ...state,
        disablerDevicesWebData: webDataSuccess([newDisablerDevice]),
      };

    case DisablerActionTypes.PUT_DISABLER_COMPLETED:
      return {
        ...state,
        disablerDevicesWebData: mapWebData((disablerDevices: DisablerDevice[]) => disablerDevices.filter((device) => device.deviceId !== action.payload.deviceId))(
          state.disablerDevicesWebData
        ),
      };

    default:
      return state;
  }
};
